import {createContext, useCallback, useContext, useMemo} from 'react';
import {assert} from 'assert-ts';
import {selectWorkMinimized, workMinimizedUpdated} from 'services/settings';
import {useAppDispatch, useAppSelector} from 'store/hooks';

type TogglerContextType = {
  workHidden: boolean;
  onToggle: () => void;
};

export const WorkToggleContext = createContext<TogglerContextType | undefined>(
  undefined,
);

export const useWorkToggleContextProviderValue = (): TogglerContextType => {
  const workMinimized = useAppSelector(selectWorkMinimized);
  const dispatch = useAppDispatch();

  const onToggle = useCallback(() => {
    dispatch(workMinimizedUpdated(!workMinimized));
  }, [dispatch, workMinimized]);

  return useMemo(
    () => ({
      workHidden: !!workMinimized,
      onToggle,
    }),
    [onToggle, workMinimized],
  );
};

export const useWorkToggleContext = (): TogglerContextType => {
  return assert(
    useContext(WorkToggleContext),
    'TogglerContext: context expected',
  );
};
